import { devRoutes } from '../constants/configs/routes';
import { prodRoutes } from '../constants/configs/routes';
import { dashboardModalTypes } from '../constants/individualPortal/dashboard/modals/dashboardModalTypes';
import { commonModalTypes } from '../constants/common/modals/commonModalTypes';
import { ssapModalTypes } from '../constants/ssap/modals/ssapModalTypes';

const {
    SSAP,
    VERIFICATION_DOCUMENTS
} = devRoutes;

const {
    VERIFICATION_DOCUMENTS: PRODUCTION_VERIFICATION_DOCUMENTS
} = prodRoutes;

// shouldBeShown - is Array of eligible locations;
// shouldNotBeShown - is Array of prohibited locations;
// if none of them has been provided - setting will be available everywhere


export const localStorageConfigs = {
    isHyperDashboardShown: {
        text: 'Show HyperDash',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean'
    },
    isUploadDocumentsDashboardShown: {
        text: 'Show Upload HyperDashboard',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean',
        shouldBeShown: [ VERIFICATION_DOCUMENTS, PRODUCTION_VERIFICATION_DOCUMENTS ]
    },
    isReactIntlWarningsShown: {
        text: 'Show React-Intl warnings',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean'
    },
    currentPage: {
        text: 'Current Page',
        value: 0,
        inputType: 'regularInput',
        outputType: 'number',
        shouldBeShown: [ SSAP ]
    },
    maxAchievedPage: {
        text: 'Max Achieved Page',
        value: 0,
        inputType: 'regularInput',
        outputType: 'number',
        switchers: true,
        shouldBeShown: [ SSAP ]
    },
    isValidatorsGeneratorResultsShown: {
        text: 'Validation generator',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean',
        shouldBeShown: [ SSAP ]
    },
    isInvalidInputsShown: {
        text: 'Invalid inputs',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean',
        shouldBeShown: [ SSAP ]
    },
    isFormValidationShown: {
        text: 'Form validation',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean',
        shouldBeShown: [ SSAP ]
    },
    isPreventerConsoleShown: {
        text: 'Preventer Tool Console',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean'
    },
    areNonStandaloneConsolesShown: {
        text: 'Standalone consoles',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean'
    },
    areSentToBackendConsolesShown: {
        text: 'Sent To Backend consoles',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean'
    },
    isCaseNumberConsoleShown: {
        text: 'CaseNumber console Test',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean'
    },
    isDataSyncConsolesShown: {
        text: 'Data Sync Console',
        value: false,
        inputType: 'checkbox',
        outputType: 'boolean'
    },
    preOpenedMenuItem: {
        text: 'Default menu item',
        value: 'default',
        options: [
            {
                value: 'default',
                text: 'No pre-selection'
            },
            ...Object.keys({
                TaxHouseholdComposition: false,
                Pages: false,
                Flags: false,
                Identifiers: false,
                JsonSetter: false,
                JsonGetter: false,
                Relations: false
            }).map(key => ({
                value: key,
                text: key
            }))
        ],
        inputType: 'dropdown',
        outputType: 'string',
        shouldBeShown: [ SSAP ]
    },
    stateCode: {
        text: 'State Code Test',
        value: 'VA',
        options: [
            {
                value: 'GA',
                text: 'Georgia'
            },
            {
                value: 'GI',
                text: 'GetInsured'
            },
            {
                value: 'ID',
                text: 'Idaho'
            },
            {
                value: 'IL',
                text: 'Illinois'
            },
            {
                value: 'OR',
                text: 'Oregon'
            },
            {
                value: 'MN',
                text: 'Minnesota'
            },
            {
                value: 'NJ',
                text: 'New Jersey'
            },
            {
                value: 'NM',
                text: 'New Mexico'
            },
            {
                value: 'NV',
                text: 'Nevada'
            },
            {
                value: 'OR',
                text: 'Oregon'
            },
            {
                value: 'PA',
                text: 'Pennsylvania'
            },
            {
                value: 'VA',
                text: 'Virginia'
            }
        ],
        inputType: 'dropdown',
        outputType: 'string'
    },
    modals: {
        text: 'Modals',
        value: 'default',
        options: [
            {
                value: 'default',
                text: 'No pre-selection'
            },
            ...Object.keys(commonModalTypes).map(modal => ({
                value: modal,
                text: modal
            })),
            ...Object.keys(dashboardModalTypes).map(modal => ({
                value: modal,
                text: modal
            })),
            ...Object.keys(ssapModalTypes).map(modal => ({
                value: modal,
                text: modal
            }))
        ],
        inputType: 'dropdown',
        outputType: 'string',
        shouldBeShown: [
            SSAP,
            VERIFICATION_DOCUMENTS
        ]
    },
    preferredRoute: {
        text: 'Preferred Route',
        value: 'SSAP',
        options: [
            {
                value: 'SSAP',
                text: 'SSAP'
            },
            {
                value: 'VERIFICATION_DOCUMENTS',
                text: 'Upload Documents (ID, PA, NJ, VA, GA, VA, NM, IL)'
            },
            {
                value: 'COMMUNICATION_PREFERENCES',
                text: 'Communication Preferences'
            },
            {
                value: 'COMMUNICATION_PREFERENCES_AC',
                text: 'Communication Preferences (Sign Up Flow)'
            },
            {
                value: 'default',
                text: 'No pre-selection'
            }
        ],
        inputType: 'dropdown',
        outputType: 'string'
    }
};